import Vue from 'vue'
import Router from 'vue-router'

import ApplicationView from './views/ApplicationView.vue'
import ConfirmationView from './views/ConfirmationView.vue'
import ErrorView from './views/ErrorView.vue'
import LoginView from './views/LoginView.vue'
import PilotView from './views/PilotView.vue'
import WelcomeView from './views/WelcomeView.vue'
import CancelView from './views/CancelView'
import LogoutView from './views/LogoutView'
import ExistingApplication from './views/ExistingApplication'
import PendingApplicationsView from './views/PendingApplicationsView'
import store from '@/store/store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'WelcomeView',
      component: WelcomeView
    },
    {
      path: '/pilot',
      name: 'PilotView',
      component: PilotView,
      meta: {
        title: 'Privacy'
      }
    },
    {
      path: '/application',
      name: 'ApplicationView',
      component: ApplicationView,
      meta: {
        title: 'Application'
      }
    },
    {
      path: '/login/:type',
      name: 'LoginView',
      component: LoginView
    },
    {
      path: '/confirmation',
      name: 'ConfirmationView',
      component: ConfirmationView,
      meta: {
        title: 'Confirmation'
      }
    },
    {
      path: '/error',
      name: 'ErrorView',
      component: ErrorView,
      meta: {
        title: 'Error'
      }
    },
    {
      path: '/cancel',
      name: 'CancelView',
      component: CancelView,
      meta: {
        title: 'Cancel'
      }
    },
    {
      path: '/logout',
      name: 'LogoutView',
      props: true,
      component: LogoutView,
      meta: {
        title: 'Logout'
      }
    },
    {
      path: '*',
      component: ErrorView
    },
    {
      path: '/ExistingApplication',
      name: 'ExistingApplication',
      props: true,
      component: ExistingApplication,
      meta: {
        title: 'Pending Application'
      }
    },
    {
      path: '/pendingApplications',
      name: 'PendingApplicationsView',
      component: PendingApplicationsView,
      meta: {
        title: 'Pending Applications'
      }
    }
  ],
  //Scroll to top when navigating back to landing page
  scrollBehavior(to) {
    if (to.name === 'WelcomeView' || to.name === 'LoginView') {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  const loginTitles = {
    timeout: 'Session Expired',
    new: 'Login',
    resume: 'Login'
  }
  const titlePrefix =
    to.name === 'LoginView' ? loginTitles[to.params.type] : to.meta.title
  const DEFAULT_TITLE = 'Emergency Assistance'
  document.title = titlePrefix
    ? `${titlePrefix} | ${DEFAULT_TITLE}`
    : DEFAULT_TITLE

  if (
    (from.name === 'LogoutView' && to.name === 'ApplicationView') ||
    (from.name === 'LogoutView' && to.name === 'ExistingApplication') ||
    (from.name === 'LogoutView' && to.name === 'PilotView')
    
  ) {    
    next()
  } else {
    next()
  }
})

export default router
